module.exports = __webpack_public_path__ + "img/whatsapp.1b2faa1a.png";